<ng-container *ngIf="!qc">
  <app-spinner></app-spinner>
</ng-container>
<ng-container *ngIf="qc && !stream">
  No suitable live stream available.
</ng-container>